export default __webpack_public_path__ + "static/media/SOL.8f61adfe.mp3";